import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AppShell from "../../components/AppShell";
import api from "../../lib/api";
import { Button } from "../../components/ui/button";
import { toast } from "sonner";

export default function Subscription() {
  const { t } = useTranslation();
  const [plans, setPlans] = useState([]);
  useEffect(() => { api.get("/payments/plans").then((r) => setPlans(r.data.filter((p) => p.lookup_key.startsWith("family")))); }, []);

  async function buy(key) {
    try {
      const r = await api.post("/payments/checkout", { lookup_key: key, quantity: 1, origin_url: window.location.origin });
      window.location.href = r.data.checkout_url;
    } catch (e) { toast.error(e?.response?.data?.detail || t("pricing.checkoutFailed")); }
  }

  return (
    <AppShell>
      <h1 className="font-adult font-bold text-3xl text-slate-900">{t("nav.subscription")}</h1>
      <p className="text-slate-600">{t("parent.subtitle")}</p>
      <div className="grid md:grid-cols-2 gap-4 mt-6">
        {plans.map((p) => (
          <div key={p.lookup_key} className="hb-card p-6">
            <div className="text-xs uppercase tracking-widest text-slate-500 font-semibold">{p.name}</div>
            <div className="font-adult font-bold text-3xl text-slate-900 mt-1">${(p.amount/100).toFixed(2)}</div>
            <Button className="mt-4 rounded-full bg-slate-900 text-white hover:bg-slate-800 w-full" onClick={() => buy(p.lookup_key)} data-testid={`buy-${p.lookup_key}`}>{t("common.getStarted")}</Button>
          </div>
        ))}
      </div>
      <p className="text-xs text-slate-500 mt-4">{t("pricing.testCardHint")}</p>
    </AppShell>
  );
}
